module.exports = __webpack_public_path__ + "static/media/logo-pdf.8402dee9.png";